@if ((this.submitted$ | async) !== true) {
  <div>
    @if (this.canWithdraw) {
      <div class="modal-header">
        {{ 'item.qa.withdrawn.modal.header' | translate }}
        <button type="button" class="close" (click)="onModalClose()" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
    } @else {
      @if (!this.canWithdraw) {
        <div class="modal-header">
          {{'item.qa.reinstate.modal.header' | translate}}
          <button type="button" class="close" (click)="onModalClose()" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      }
    }
    <div class="modal-body">
      <div class="form-group">
        <label for="reason">{{ this.canWithdraw ? ('qa-withdrawn.create.modal.form.summary.label' | translate)
        : ('qa-reinstate.create.modal.form.summary.label' | translate) }}</label>
        <label for="reason">{{ this.canWithdraw ? ('qa-withdrawn.create.modal.form.summary2.label' | translate)
        : ('qa-reinstate.create.modal.form.summary2.label' | translate) }}</label>
        <textarea class="form-control" id="reason"
          rows="6"
          [(ngModel)]="reason"
                placeholder="{{ this.canWithdraw ? ('qa-withdrown.modal.form.summary.placeholder' | translate)
                                                 : ('qa-reinstate.modal.form.summary.placeholder' | translate) }}"
        name="message"></textarea>
      </div>
    </div>
    <div class="modal-footer space-children-mr">
      <button class="btn btn-outline-secondary btn-sm ms-0"
        type="button"
        (click)="onModalClose()"
        title="{{'item.qa.withdrawn-reinstate.create.modal.button.cancel.tooltip' | translate}}">
        <i class="fas fa-times fa-fw"></i> {{'item.qa.withdrawn-reinstate.create.modal.button.cancel' | translate}}
      </button>
      <button class="btn btn-success btn-sm ms-0"
        type="submit"
        (click)="onModalSubmit()"
        title="{{'item.qa.withdrawn-reinstate.modal.button.confirm.tooltip' | translate}}">
        <i class="fas fa-check fa-fw"></i> {{ this.canWithdraw ? ('qa-withdrown.create.modal.button.confirm' | translate)
        : ('qa-reinstate.create.modal.button.confirm' | translate) }}
      </button>
    </div>
  </div>
} @else {
  <div class="modal-header">{{'item.qa.withdrawn.modal.submitted.header' | translate}}</div>
  <div class="modal-body">
    <div class="d-flex justify-content-center">
      <ds-loading [showMessage]="false"></ds-loading>
    </div>
  </div>
}


